import styles from './Mortgage.module.scss';

export const MortgageCalculators = () => {
  return (
    <>
      <div className={styles.firstHeading}>Mortgage Calculators</div>

      <div className={styles.primaryBody}>Mortgage Calculators</div>
    </>
  );
};

export default MortgageCalculators;
